import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Shield, CreditCard, Lock, User, Mail, CheckCircle } from 'lucide-react';
export function CheckoutPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [expiry, setExpiry] = useState('');
  const [cvv, setCvv] = useState('');
  const handleCheckout = (e: React.FormEvent) => {
    e.preventDefault();
    window.location.hash = '#thankyou';
  };
  return <div className="min-h-screen bg-cream font-body text-charcoal pb-20" data-id="element-175">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 py-4 px-4 sticky top-0 z-10" data-id="element-176">
        <div className="max-w-5xl mx-auto flex items-center justify-between" data-id="element-177">
          <button onClick={() => window.location.hash = ''} className="flex items-center text-warm-gray hover:text-orange transition-colors font-medium text-sm" data-id="element-178">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-179" />
            Volver
          </button>
          <div className="flex items-center text-green font-bold text-sm" data-id="element-180">
            <Lock className="w-4 h-4 mr-1.5" data-id="element-181" />
            Pago Seguro 256-bit SSL
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 pt-8 md:pt-12" data-id="element-182">
        <div className="text-center mb-10" data-id="element-183">
          <h1 className="font-heading font-bold text-3xl md:text-4xl text-charcoal mb-3" data-id="element-184">
            Completa tu pedido
          </h1>
          <p className="text-warm-gray" data-id="element-185">
            Estás a un paso de eliminar el dolor de ciática.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start" data-id="element-186">
          {/* Left Column: Payment Form */}
          <div className="lg:col-span-7 bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8" data-id="element-187">
            <h2 className="font-heading font-bold text-xl mb-6 flex items-center" data-id="element-188">
              <span className="bg-navy text-white w-8 h-8 rounded-full flex items-center justify-center text-sm mr-3" data-id="element-189">
                1
              </span>
              Información de Contacto
            </h2>

            <form onSubmit={handleCheckout} className="space-y-6" data-id="element-190">
              <div className="space-y-4" data-id="element-191">
                <div data-id="element-192">
                  <label className="block text-sm font-medium text-warm-gray mb-1.5" data-id="element-193">
                    Nombre Completo
                  </label>
                  <div className="relative" data-id="element-194">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-195">
                      <User className="h-5 w-5 text-gray-400" data-id="element-196" />
                    </div>
                    <input type="text" required value={name} onChange={e => setName(e.target.value)} className="block w-full pl-10 pr-3 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange/50 focus:border-orange transition-colors outline-none" placeholder="Ej. Juan Pérez" data-id="element-197" />
                  </div>
                </div>

                <div data-id="element-198">
                  <label className="block text-sm font-medium text-warm-gray mb-1.5" data-id="element-199">
                    Correo Electrónico (Donde enviaremos el acceso)
                  </label>
                  <div className="relative" data-id="element-200">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-201">
                      <Mail className="h-5 w-5 text-gray-400" data-id="element-202" />
                    </div>
                    <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange/50 focus:border-orange transition-colors outline-none" placeholder="tu@email.com" data-id="element-203" />
                  </div>
                </div>
              </div>

              <div className="pt-6 border-t border-gray-100" data-id="element-204">
                <h2 className="font-heading font-bold text-xl mb-6 flex items-center" data-id="element-205">
                  <span className="bg-navy text-white w-8 h-8 rounded-full flex items-center justify-center text-sm mr-3" data-id="element-206">
                    2
                  </span>
                  Pago Seguro
                </h2>

                <div className="space-y-4" data-id="element-207">
                  <div data-id="element-208">
                    <label className="block text-sm font-medium text-warm-gray mb-1.5" data-id="element-209">
                      Número de Tarjeta
                    </label>
                    <div className="relative" data-id="element-210">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-211">
                        <CreditCard className="h-5 w-5 text-gray-400" data-id="element-212" />
                      </div>
                      <input type="text" required value={cardNumber} onChange={e => setCardNumber(e.target.value)} className="block w-full pl-10 pr-3 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange/50 focus:border-orange transition-colors outline-none font-mono" placeholder="0000 0000 0000 0000" maxLength={19} data-id="element-213" />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4" data-id="element-214">
                    <div data-id="element-215">
                      <label className="block text-sm font-medium text-warm-gray mb-1.5" data-id="element-216">
                        Vencimiento
                      </label>
                      <input type="text" required value={expiry} onChange={e => setExpiry(e.target.value)} className="block w-full px-3 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange/50 focus:border-orange transition-colors outline-none font-mono" placeholder="MM/AA" maxLength={5} data-id="element-217" />
                    </div>
                    <div data-id="element-218">
                      <label className="block text-sm font-medium text-warm-gray mb-1.5" data-id="element-219">
                        CVV
                      </label>
                      <input type="text" required value={cvv} onChange={e => setCvv(e.target.value)} className="block w-full px-3 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange/50 focus:border-orange transition-colors outline-none font-mono" placeholder="123" maxLength={4} data-id="element-220" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="pt-6" data-id="element-221">
                <motion.button whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} type="submit" className="w-full bg-orange hover:bg-orange-hover text-white font-bold text-lg py-4 px-6 rounded-lg shadow-lg uppercase tracking-wide transition-colors flex items-center justify-center" data-id="element-222">
                  <Lock className="w-5 h-5 mr-2" data-id="element-223" />
                  COMPLETAR MI COMPRA - $6.39 USD
                </motion.button>
                <div className="flex items-center justify-center mt-4 text-sm text-warm-gray" data-id="element-224">
                  <Shield className="w-4 h-4 mr-1.5 text-green" data-id="element-225" />
                  <span data-id="element-226">Garantía de satisfacción de 60 días</span>
                </div>
              </div>
            </form>
          </div>

          {/* Right Column: Order Summary */}
          <div className="lg:col-span-5 space-y-6" data-id="element-227">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8" data-id="element-228">
              <h3 className="font-heading font-bold text-xl mb-6 border-b border-gray-100 pb-4" data-id="element-229">
                Resumen de tu pedido
              </h3>

              <div className="flex items-start justify-between mb-6" data-id="element-230">
                <div data-id="element-231">
                  <h4 className="font-bold text-charcoal mb-1" data-id="element-232">
                    Protocolo SOS Nervio Ciático
                  </h4>
                  <p className="text-sm text-warm-gray" data-id="element-233">
                    Acceso digital inmediato
                  </p>
                </div>
                <div className="text-right" data-id="element-234">
                  <span className="block text-sm text-warm-gray line-through" data-id="element-235">
                    $97.00
                  </span>
                  <span className="block font-bold text-lg text-charcoal" data-id="element-236">
                    $6.39
                  </span>
                </div>
              </div>

              <div className="space-y-3 mb-6" data-id="element-237">
                <div className="flex items-start text-sm" data-id="element-238">
                  <CheckCircle className="w-4 h-4 text-green mr-2 mt-0.5 flex-shrink-0" data-id="element-239" />
                  <span className="text-warm-gray" data-id="element-240">
                    Guía Paso a Paso (14 días)
                  </span>
                </div>
                <div className="flex items-start text-sm" data-id="element-241">
                  <CheckCircle className="w-4 h-4 text-green mr-2 mt-0.5 flex-shrink-0" data-id="element-242" />
                  <span className="text-warm-gray" data-id="element-243">
                    Técnica de la Esfinge (4 min)
                  </span>
                </div>
                <div className="flex items-start text-sm" data-id="element-244">
                  <CheckCircle className="w-4 h-4 text-green mr-2 mt-0.5 flex-shrink-0" data-id="element-245" />
                  <span className="text-warm-gray" data-id="element-246">
                    Protocolo de Sueño Sin Dolor
                  </span>
                </div>
                <div className="flex items-start text-sm" data-id="element-247">
                  <CheckCircle className="w-4 h-4 text-green mr-2 mt-0.5 flex-shrink-0" data-id="element-248" />
                  <span className="text-warm-gray" data-id="element-249">
                    Plan de Blindaje Lumbar
                  </span>
                </div>
                <div className="flex items-start text-sm" data-id="element-250">
                  <CheckCircle className="w-4 h-4 text-orange mr-2 mt-0.5 flex-shrink-0" data-id="element-251" />
                  <span className="text-charcoal font-medium" data-id="element-252">
                    BONO: Lista de compras SOS
                  </span>
                </div>
              </div>

              <div className="border-t border-gray-100 pt-4 flex items-center justify-between" data-id="element-253">
                <span className="font-bold text-charcoal" data-id="element-254">Total a pagar</span>
                <span className="font-heading font-black text-2xl text-charcoal" data-id="element-255">
                  $6.39{' '}
                  <span className="text-sm font-body font-normal text-warm-gray" data-id="element-256">
                    USD
                  </span>
                </span>
              </div>
            </div>

            <div className="bg-cream border border-green/20 rounded-xl p-5 flex items-start" data-id="element-257">
              <Shield className="w-8 h-8 text-green mr-3 flex-shrink-0" data-id="element-258" />
              <div data-id="element-259">
                <h4 className="font-bold text-charcoal text-sm mb-1" data-id="element-260">
                  Pago 100% Seguro
                </h4>
                <p className="text-xs text-warm-gray leading-relaxed" data-id="element-261">
                  Tus datos están protegidos con encriptación SSL de 256 bits.
                  No almacenamos la información de tu tarjeta de crédito.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
}